module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/58d87881bfa7e0bacf6c1bf85ebd98ff.png";